// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"e797c0ee","355":"93f1c9ec","433":"ac68090c"}[chunkId] + ".chunk.js";
};